import { routePaths } from "../root/routePaths";

// Rapportfanene i URL-en (?fane=timer), så de kan lenkes til og overlever
// refresh og tilbake/frem (PRD US10.2). Ukjent fane gir Nøkkeltall.
export const REPORT_TAB_SLUGS = {
  key_figures: "nokkeltall",
  time: "timer",
  sales: "salg",
  customers: "kunder",
  invoice_basis: "fakturagrunnlag",
  unbilled: "ufakturert",
  questions: "sporsmal",
} as const;

export type ReportTab = keyof typeof REPORT_TAB_SLUGS;
export const DEFAULT_REPORT_TAB: ReportTab = "key_figures";

export const isReportSlug = (slug: string | null) =>
  Object.values(REPORT_TAB_SLUGS).some((s) => s === slug);

export const reportTabFromSlug = (slug: string | null): ReportTab =>
  (Object.entries(REPORT_TAB_SLUGS).find(([, s]) => s === slug)?.[0] as
    | ReportTab
    | undefined) ?? DEFAULT_REPORT_TAB;

export const reportsPath = (tab: ReportTab) =>
  tab === DEFAULT_REPORT_TAB
    ? routePaths.reports
    : `${routePaths.reports}?fane=${REPORT_TAB_SLUGS[tab]}`;
